<template>
  <div class="avatar" style="text-align: center;">
    <van-nav-bar @click-left="clickBack" left-arrow />

    <div style="margin: 1rem; border-radius: 0.2em;">
      <img :src="avatar" style="height: 100%; width: 100%;" />
    </div>
    <div class="uploader" v-if="getPersonType != 13">
      <input
        type="file"
        ref="file"
        @change="onChange"
        name="file"
        accept="image/*"
      />
      <van-button
        v-if="getPersonType != 13"
        icon="plus"
        type="info"
        :loading="btn_loading"
        :disabled="btn_disabled"
        loading-text="保存中..."
        @click="!btn_loading && $refs.file.click()"
        >修改</van-button
      >
    </div>
  </div>
</template>

<script>
// import { compressAccurately } from 'image-conversion'
import { upload } from '@/utils/upload'

export default {
  data() {
    return {
      curFileList: [],
      avatar: '',
      btn_loading: false,
      btn_disabled: false,
    }
  },
  computed: {
    getPersonType() {
      return (
        localStorage.getItem('userInfo') &&
        JSON.parse(localStorage.getItem('userInfo')).personType
      )
    },
  },
  created() {
    let userInfo =
      localStorage.getItem('userInfo') &&
      JSON.parse(localStorage.getItem('userInfo'))
    if (userInfo) {
      this.avatar = userInfo.avatar || require('@/assets/images/avatar.png')
      if (userInfo.personType == 13) {
        this.btn_disabled = true
      }
    }
  },
  methods: {
    clickBack() {
      this.$router.go(-1)
    },
    async onChange(e) {
      if (e && e.target && e.target.files && e.target.files.length) {
        let file = e.target.files[0]
        try {
          this.btn_loading = true
          // this.btn_loading = true
          //   const res = await compressAccurately(file, 200)
          //   let fileObj = new File([res], file.name, {
          //     type: res.type,
          //   })
          //   let formData = new FormData()
          //   formData.append('file', fileObj)
          //   const { code, data, msg } = await this.$https.upload(formData)
          //   if (code !== 200) {
          //     this.$toast(msg)
          //     return false
          //   }
          //   const { realm, address } = data
          try {
            this.avatar = await upload(file)
          } catch (error) {
            this.avatar = ''
          }
          let postParams =
            localStorage.getItem('userInfo') &&
            JSON.parse(localStorage.getItem('userInfo'))
          postParams.avatar = this.avatar
          this.axios
            .post('student-consumer/api/user/updateTpdUser', postParams)
            .then((res) => {
              if (res.code === 200) {
                if (res.data) {
                  localStorage.setItem('userInfo', JSON.stringify(postParams))
                }
                this.$toast('保存成功')
                this.btn_loading = false
              } else {
                this.$toast(res.msg)
                this.btn_loading = false
              }
            })
            .catch((err) => {
              console.log(err)
              this.btn_loading = false

              this.$toast('服务器错误，请联系管理员')
            })
            .finally((_) => {
              this.btn_loading = false
              this.btn_loading = false
              this.$refs.file.value = ''
            })
        } catch (error) {
          console.log(error)
          this.$toast('服务器错误，请联系管理员')
        } finally {
          this.btn_loading = false
          this.btn_loading = false
          this.$refs.file.value = ''
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.avatar {
  input[type='file'] {
    width: 12em;
    padding: 0 15px;
    height: 44px;
    position: absolute;
    z-index: -1;
    opacity: 0;
  }
  .van-button {
    width: 12em;
  }
}
</style>
